// silenceLogs.js — Disable verbose console output in production builds.
// Keeps console.warn and console.error so we still catch real issues in
// monitoring tools. Imported once from index.js before the app renders.

if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.trace = noop;
}
